var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHushallsavfall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_2_00000045596955584585362980000003647296348392222616_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87 111.3",
    style: {
      enableBackground: "new 0 0 87 111.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#FFFFFF;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7,111c0,0-23.6,0.6-29.9-15.4s-4.8-41,4-53S28.4,29.5,30.4,29s-16.5-1.2-18.2-3.3c-0.9-1.1-6-12-6.8-16.8 s16.7-7.3,18.4-5.8s12,18.1,12,18.1h3.2c0,0-0.3-9.5-0.3-11.2S52.3-0.5,56.1,0C60.7,0.6,67,5.3,66.9,8.6c-0.1,1.8-1.5,6.6-1.5,6.6 s-11.9,9.4-13,10.4c-0.6,0.5-1.9,4.6,3.7,5.9c8.9,2,22.7,11.1,27.5,18.5c3.1,4.8,5.8,30.3,0,46c-2.6,7-12.5,13-19.5,14.5 C56.8,112,33.6,111,33.7,111L33.7,111z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,41.3c0,0-4.3,10.5,0,16.8s6.5,7.1,8.2,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.5,38.5c0,0,11.2,3.6,21,15.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.6,24.2c0,0-4.5,6-0.5,10.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.4,39.6c0,0-8,4-11,15.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.4,24.4c0,0,7.8,5.8,9.6,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.6,24.2c1.8,0.9,9.7-16.4,19.3-16.1C64.2,10,49.3,22.4,38.6,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37,24.2c0,0-27.8-4.6-22.1-13.4C21.4,5.8,32.7,22.3,37,24.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHushallsavfall);
export default __webpack_public_path__ + "static/media/icon-hushallsavfall.c731f7f24ec248e76d6b4af504e43cae.svg";
export { ForwardRef as ReactComponent };